import { render, staticRenderFns } from "./EmmaAvatar.vue?vue&type=template&id=abfef682&"
import script from "./EmmaAvatar.vue?vue&type=script&lang=ts&"
export * from "./EmmaAvatar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports